module.exports = __webpack_public_path__ + "static/scale-model-of-joliet-illinois-201a58820097a1d540baf41453e0b238.png";